export const BLOGS = 'blogs'
